import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { auth } from "./firebase-config";
import LandingPage from "./components/LandingPage";
import QuestionnaireView from "./components/QuestionnaireView";
import EpitomeView from "./components/EpitomeView";
import Auth from "./components/Auth";
import PCPView from "./components/PCPView";
import PerformanceCoachingView from "./components/PerformanceCoachingView";
import ClinicalStudyView from "./components/ClinicalStudyView";
import ExampleReportView from "./components/ExampleReportView";
import PricingView from "./components/PricingView";
import NewsView from "./components/NewsView";
import PeopleView from "./components/PeopleView";
import FAQView from "./components/FAQView";
import CorporateView from "./components/CorporateView";
import PrivacyView from "./components/PrivacyView";
import ContactView from "./components/ContactView";
import LoginModal from "./components/LoginModal";
import { onAuthStateChanged } from "firebase/auth";

function App() {
  const [user, setUser] = useState(null);
  const [showAuth, setShowAuth] = useState(false);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const handleLoginClick = () => {
    setShowAuth(true);
  };

  const handleLoginClose = () => {
    setShowAuth(false);
  };

  return (
    <Router>
      {showAuth && <Auth onClose={handleLoginClose} />}
      <Routes>
        <Route
          path="/"
          element={<LandingPage user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/questionnaire"
          element={
            <QuestionnaireView user={user} onLoginClick={handleLoginClick} />
          }
        />
        <Route
          path="/epitome"
          element={
            <EpitomeView user={user} onLoginClick={handleLoginClick} />
          }
        />
        <Route
          path="/pcp"
          element={<PCPView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/performance-coaching"
          element={
            <PerformanceCoachingView
              user={user}
              onLoginClick={handleLoginClick}
            />
          }
        />
        <Route
          path="/clinical-study"
          element={
            <ClinicalStudyView user={user} onLoginClick={handleLoginClick} />
          }
        />
        <Route
          path="/example-report"
          element={
            <ExampleReportView user={user} onLoginClick={handleLoginClick} />
          }
        />
        <Route
          path="/pricing"
          element={<PricingView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/news"
          element={<NewsView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/people"
          element={<PeopleView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/faq"
          element={<FAQView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/corporate"
          element={
            <CorporateView user={user} onLoginClick={handleLoginClick} />
          }
        />
        <Route
          path="/privacy"
          element={<PrivacyView user={user} onLoginClick={handleLoginClick} />}
        />
        <Route
          path="/contact"
          element={<ContactView user={user} onLoginClick={handleLoginClick} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
